var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useContext, useEffect } from "react";
import { ModalStateContext } from '../context/modal-context';
import { isString } from 'lodash';
export var useModal = function () {
  var _a = __read(useContext(ModalStateContext), 2),
    state = _a[0],
    setState = _a[1];
  var component = state.component,
    color = state.color,
    opacity = state.opacity,
    title = state.title,
    _b = state.zIndex,
    zIndex = _b === void 0 ? 200 : _b;
  useEffect(function () {
    if (document !== undefined && document.body !== undefined) {
      if (component) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  }, [component]);
  return {
    show: function (component, colorOrOptions) {
      var newState = isString(colorOrOptions) ? __assign(__assign({}, state), {
        color: colorOrOptions,
        component: component
      }) : __assign(__assign(__assign({}, state), colorOrOptions || {}), {
        component: component
      });
      setState(newState);
    },
    hide: function () {
      setState(__assign(__assign({}, state), {
        title: '',
        component: null
      }));
    },
    color: color,
    title: title,
    zIndex: zIndex,
    opacity: opacity || 0.65,
    isVisible: !!component,
    component: state.component
  };
};